import {
  API_ERROR,
  CATEGORY,
  CATEGORY_LIST_SUCCESSFUL,
  CATEGORY_ADD,
  CATEGORY_ADD_SUCCESSFUL,
  CATEGORY_EDIT,
  CATEGORY_EDIT_SUCCESSFUL,
  CATEGORY_DELETE,
  CATEGORY_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
} from "./actionTypes";

export const getCategorys = () => {
  return {
    type: CATEGORY,
  };
};

export const CategoryListSuccessful = (category) => {
  return {
    type: CATEGORY_LIST_SUCCESSFUL,
    payload: category,
  };
};

export const CategoryAdd = (category, history) => {
  return {
    type: CATEGORY_ADD,
    payload: { category, history },
  };
};

export const CategoryAddSuccessful = (response) => {
  return {
    type: CATEGORY_ADD_SUCCESSFUL,
    payload: response,
  };
};

export const CategoryEdit = (data) => {
  return {
    type: CATEGORY_EDIT,
    payload: data,
  };
};

export const CategoryEditSuccessful = (response) => {
  return {
    type: CATEGORY_EDIT_SUCCESSFUL,
    payload: response,
  };
};

export const CategoryDelete = (CTAId, history) => {
  return {
    type: CATEGORY_DELETE,
    payload: { CTAId, history },
  };
};

export const SetEditData = (data) => {
  return {
    type: CATEGORY_SETROWDATA,
    payload: data,
  };
};

export const model_open = () => {
  return {
    type: MODEL_OPEN,
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
